"use strict";
/*
  Email (MIME) parsing library. Copyright (C) 2020-2021 Vereign AG

  This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General
  Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option)
  any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
  warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
  details.

  You should have received a copy of the GNU Affero General Public License along with this program. If not, see
  https://www.gnu.org/licenses/.

  In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to
  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.vncMailSeparatorMatcher = exports.outlookWebSeparatorMatcher = exports.gmailSeparatorMatcher = exports.outlookDesktopSeparatorMatcher = void 0;
const GMAIL_QUOTE_CLASS = "gmail_quote";
const OUTLOOK_APPENDONSEND_ID = "appendonsend";
const VNCMAIL_SEPARATOR_ID = "seperator";
/**
 * Function looks up for div with a specific style provided by Outlook Desktop
 * @param element
 */
const outlookDesktopSeparatorMatcher = (element) => {
    const style = element.getAttribute("style");
    if (style) {
        const cssProps = style.split(";").reduce((acc, prop) => {
            const propSplit = prop.split(":");
            return Object.assign(acc, { [propSplit[0]]: propSplit[1] });
        }, {});
        const border = cssProps["border"];
        const borderTop = cssProps["border-top"];
        const padding = cssProps["padding"];
        // #b5c4df - provided by MacOS
        // #e1e1e1 - provided by Windows
        const borderTopRegExp = new RegExp(/solid (#b5c4df|#e1e1e1) 1[.0]*pt/gi);
        // inches provided by MacOS
        // centimeters provided by Windows
        const paddingRegExp = new RegExp(/3[.0]*pt 0(cm|in) 0(cm|in) 0(cm|in)/gi);
        if (border === "none" &&
            borderTopRegExp.test(borderTop) &&
            paddingRegExp.test(padding)) {
            return true;
        }
    }
    return false;
};
exports.outlookDesktopSeparatorMatcher = outlookDesktopSeparatorMatcher;
const gmailSeparatorMatcher = (element) => {
    return (element.nodeName === "DIV" &&
        element.getAttribute("class") === GMAIL_QUOTE_CLASS);
};
exports.gmailSeparatorMatcher = gmailSeparatorMatcher;
const outlookWebSeparatorMatcher = (element) => {
    const id = element.getAttribute("id");
    return (id === OUTLOOK_APPENDONSEND_ID || id === `x_${OUTLOOK_APPENDONSEND_ID}` // Attempt to also access XSS sanitized value
    );
};
exports.outlookWebSeparatorMatcher = outlookWebSeparatorMatcher;
const vncMailSeparatorMatcher = (element) => {
    const id = element.getAttribute("id");
    return id === VNCMAIL_SEPARATOR_ID;
};
exports.vncMailSeparatorMatcher = vncMailSeparatorMatcher;
